<template>
  <div class="index">
    <div class="hero">
      <div class="container">
        <p class="hero-tag">成都育迪科技 · 二手交易</p>
        <h1>发布闲置，找到对的买家</h1>
        <p class="hero-desc">覆盖二手车、家具、手机、电脑、图书和电动车。发布内容先审后发，审核通过后在对应类目公开展示。</p>
        <el-button type="primary" @click="goPublish">立即发布</el-button>
      </div>
    </div>
    <div class="container">
      <div class="section-title">交易类目</div>
      <ul class="category-list clearfix" v-loading="loading">
        <li
          v-for="item in categories"
          :key="item.categoryId"
          class="category-item"
          @click="goCategory(item.categoryId)"
        >
          <div class="cate-name">{{ item.name }}</div>
          <p>查看该分类下已审核通过的闲置信息</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    categories() {
      return this.$store.state.categories
    }
  },
  created() {
    this.loading = true
    this.$store.dispatch('fetchCategories', true).catch(() => {}).finally(() => {
      this.loading = false
    })
  },
  methods: {
    goCategory(id) {
      this.$router.push('/category/' + id)
    },
    goPublish() {
      this.$router.push('/publish')
    }
  }
}
</script>
<style lang="less" scoped>
.index {
  padding-bottom: 48px;
}
.hero {
  background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 48%, #38bdf8 100%);
  color: #fff;
  padding: 56px 0 64px;
  margin-bottom: 32px;
  h1 {
    font-size: 32px;
    line-height: 44px;
    margin: 12px 0 16px;
    max-width: 720px;
  }
}
.hero-tag {
  font-size: 13px;
  letter-spacing: 2px;
  opacity: 0.85;
}
.hero-desc {
  max-width: 640px;
  line-height: 26px;
  margin-bottom: 24px;
  opacity: 0.92;
}
.section-title {
  font-size: 20px;
  font-weight: 600;
  margin: 8px 0 16px;
  color: #111827;
}
.category-item {
  float: left;
  width: 361px;
  margin-right: 20px;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 8px;
  padding: 24px 20px;
  min-height: 120px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  &:nth-child(3n) {
    margin-right: 0;
  }
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.12);
  }
  p {
    color: #6b7280;
    font-size: 13px;
    line-height: 20px;
    margin-top: 10px;
  }
}
.cate-name {
  font-size: 18px;
  font-weight: 600;
  color: #2563eb;
}
</style>
